import { Injectable } from "@angular/core";
import * as elementResizeDetectorMaker from "element-resize-detector";

@Injectable()
export class ResizeService {
    private erd: elementResizeDetectorMaker.Erd;
    constructor() {
        this.erd=elementResizeDetectorMaker();
    }

    addListener(element: HTMLElement,callback: (elem: HTMLElement) => void): void {
        this.erd.listenTo(element,callback);
    }

    removeResizeEventListener(element: HTMLElement): void {
        this.erd.uninstall(element);
    }
}